import * as React from "react";

import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";
import twMerge from "@replo/design-system/utils/twMerge";
import { useDraftElementMetadata } from "@v1/hooks/useDraftElementMetadata";
import { formatDistanceToNowStrict } from "date-fns";
import { Circle } from "lucide-react";

const PublishedStatus = () => {
  const elementMetadata = useDraftElementMetadata();
  const isPublished = elementMetadata?.isPublished;
  const publishedAt = elementMetadata?.publishedAt;

  const difference = publishedAt
    ? formatDistanceToNowStrict(new Date(publishedAt))
    : null;

  const label =
    isPublished && difference
      ? `Last Published ${difference} ago`
      : "Not Published";

  return (
    <div
      className={twMerge(
        "text-muted flex items-center gap-2 text-sm font-medium",
        isPublished && "text-emerald",
      )}
    >
      <Tooltip content={label} triggerAsChild>
        <span tabIndex={0}>
          <Circle className="fill-current" size={8} />
        </span>
      </Tooltip>
    </div>
  );
};

export default PublishedStatus;
